import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";
import moment from 'moment';

const log = require("loglevel").getLogger("campaignReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	campaigns: null,
	members: {},
	dropdowns: {},
	lastUpdated: new Date()
});

function campaignReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset campaign state");
			return initialState;
		}
		case actionTypes.CAMPAIGN_MEMBERS_LOADED: {
			let {members} = state;
			members[action.campaignId] = action.data;

			return {
				...state,
				members,
				lastUpdated: new Date()
			};
		}
		case actionTypes.CAMPAIGN_LOADED: {
			const loadedCampaign = action.data;
			let {campaigns} = state;

			const index = (campaigns || []).findIndex(h => h.campaign_id === loadedCampaign.campaign_id);

			if(index > -1) {
				campaigns[index] = loadedCampaign;
			}
			else {
				campaigns = [loadedCampaign];
			}

			return {
				...state,
				campaigns
			};
		}
		case actionTypes.CAMPAIGNS_LOADED: {
			const loadedCampaigns = action.data;

			loadedCampaigns.forEach(lc => {
				lc['start_date'] = moment(new Date(lc['start_date'])).format("YYYY-MM-DD HH:mm:ss");
				lc['end_date'] = moment(new Date(lc['end_date'])).format("YYYY-MM-DD HH:mm:ss");
				lc['next_step_date'] = moment(new Date(lc['next_step_date'])).format("YYYY-MM-DD HH:mm:ss");
			});

			return {
				...state,
				campaigns: action.data
			};
		}
		case actionTypes.DROPDOWN_VALUES_LOADED: {
			const {dropdowns} = state;
			dropdowns[action.key] = action.data;

			return {
				...state,
				dropdowns
			}
		}
		default:
			return state;
	}
}

export default campaignReducer;
